/* star cursor — a sparkle that trails the pointer and changes shape by what it's over.
   fine pointers only; honors prefers-reduced-motion; native cursor stays on touch. */
(function () {
  'use strict';
  if (!window.matchMedia('(pointer: fine)').matches) return;
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  // regular five-point star, centered in the 36×36 viewBox (R≈16.5, r≈6.3)
  var STAR = 'M18 1.5 L21.7 12.9 L33.7 12.9 L24 19.95 L27.7 31.35 L18 24.3 L8.3 31.35 L12 19.95 L2.3 12.9 L14.3 12.9 Z';

  // ---- the star itself (wrapper follows the pointer; inner svg holds the variant look)
  var el = document.createElement('div');
  el.className = 'starcursor gone';
  el.setAttribute('aria-hidden', 'true');
  el.innerHTML =
    '<svg viewBox="0 0 36 36" width="36" height="36">' +
    '<circle class="sc-ring" cx="18" cy="18" r="15"/>' +
    '<path class="sc-star" d="' + STAR + '"/>' +
    '</svg>';

  // ---- the trail (one canvas, ~16 fading points — cheap, transform-free)
  var cv = document.createElement('canvas');
  cv.className = 'cursor-trail';
  cv.setAttribute('aria-hidden', 'true');
  var ctx = cv.getContext('2d');
  var dpr = Math.min(window.devicePixelRatio || 1, 2);

  function sizeCanvas() {
    cv.width = Math.round(innerWidth * dpr);
    cv.height = Math.round(innerHeight * dpr);
    cv.style.width = innerWidth + 'px';
    cv.style.height = innerHeight + 'px';
    ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
  }
  window.addEventListener('resize', sizeCanvas, { passive: true });

  document.body.appendChild(cv);
  document.body.appendChild(el);
  document.body.classList.add('has-cursor');
  sizeCanvas();

  var x = innerWidth / 2, y = innerHeight / 2, tx = x, ty = y;
  var trail = [];
  var visible = false, running = false;

  function loop() {
    running = true;
    requestAnimationFrame(function () {
      x += (tx - x) * 0.22;
      y += (ty - y) * 0.22;
      el.style.transform = 'translate3d(' + x.toFixed(1) + 'px,' + y.toFixed(1) + 'px,0)';

      // trail: newest first, fade out as it ages
      trail.unshift(x + ',' + y);
      if (trail.length > 16) trail.pop();
      ctx.clearRect(0, 0, innerWidth, innerHeight);
      if (visible) {
        for (var i = trail.length - 1; i > 0; i--) {
          var p = trail[i].split(',');
          var a = (1 - i / 16);
          ctx.globalAlpha = a * a * 0.5;
          ctx.beginPath();
          ctx.arc(+p[0], +p[1], 0.6 + a * 3.2, 0, 6.283);
          ctx.fillStyle = '#FFB53F';
          ctx.fill();
        }
        ctx.globalAlpha = 1;
      }

      var moving = Math.abs(tx - x) > 0.4 || Math.abs(ty - y) > 0.4;
      var settling = trail.length > 1;
      if (moving || settling) loop(); else { running = false; ctx.clearRect(0, 0, innerWidth, innerHeight); trail.length = 0; }
    });
  }

  window.addEventListener('pointermove', function (e) {
    tx = e.clientX; ty = e.clientY;
    if (!visible) { visible = true; el.classList.remove('gone'); }
    if (!running) loop();
  }, { passive: true });

  // ---- variant by hover target
  var LINK = 'a, button, .btn, .back-link';
  var HEAD = '.hero-title, .sec-title, .paper-title, .menu-h, .lu-name, .mid-quote, .big-sign, h1, h2';
  var MEDIA = 'img, picture, figure, .lu-photo, .legend-gallery, .paper-hero, .marquee';
  document.addEventListener('pointerover', function (e) {
    var t = e.target;
    if (!t.closest) return;
    var v = t.closest(LINK) ? 'link' : t.closest(HEAD) ? 'head' : t.closest(MEDIA) ? 'media' : '';
    if (el.dataset.variant !== v) { el.dataset.variant = v; el.className = 'starcursor' + (v ? ' is-' + v : '') + (visible ? '' : ' gone'); }
  });

  window.addEventListener('pointerdown', function () { el.classList.add('down'); });
  window.addEventListener('pointerup', function () { el.classList.remove('down'); });
  document.documentElement.addEventListener('pointerleave', function () {
    visible = false; el.classList.add('gone');
  });
})();
